import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  className?: string;
  children?: React.ReactNode;
}

export const FltBenefitBox = styled.div<IProps>`
  & + & {
    margin-top: 28px;
  }

  .title {
    margin-bottom: 4px;
    font-size: 13px;
    line-height: 130%;
    color: #999;
  }

  .list {
    ${mixin.flex({ wrap: 'wrap', justify: 'flex-start', align: 'baseline' })};
    row-gap: 4px;

    .item {
      width: 50%;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    & + & {
      margin-top: ${mixin.pxToVw('28')};
    }

    .title {
      margin-bottom: ${mixin.pxToVw('4')};
      font-size: ${mixin.pxToVw('13')};
    }

    .list {
      row-gap: ${mixin.pxToVw('4')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .title {
      margin-bottom: 6px;
      font-size: 14px;
    }

    .list {
      row-gap: 4px;

      .item {
        width: 50%;
      }
    }
  }
`;
